<template>
  <div>
    <Cabecera :hamburguer="true" />

    <Banner titulo=" " style="flex: 1 0 100%" />

    <div class="main">
      <MenuInicio v-if="biggerThanPhone" :can-close="false" class="menuInicio" />

      <div class="contenido">
        <div class="tarjetario">
          <PromocionSaludSeVital v-if="visiblePromocionSaludSeVital" class="tarjeta" />
          <NuevoReglamentoCirculacion v-if="visibleNuevoReglamentoCirculacion" class="tarjeta" />
          <PromocionRegaloAspirador v-if="visiblePromocionRegaloAspirador" class="tarjeta"/>
          <PromocionSalud1MesGratis v-if="visiblePromocionSeguroSalud1MesGratis" class="tarjeta" />
          <PromocionMesMMTFebrero2026 v-if="visiblePromocionMesMMTFebrero2026" class="tarjeta"/>
          <PromocionBlackFriday2025 v-if="visiblePromocionBlackFriday2025" class="tarjeta" />
          <AsistenciaAuto v-if="visibleAsistenciaAuto" class="tarjeta" />
          <TraeUnAmigo v-if="visibleTraeUnAmigo" class="tarjeta" />
          <SeguroDecesos v-if="visibleSeguroDecesos" class="tarjeta" />
          <SeguroHogar v-if="visibleSeguroHogar" class="tarjeta"/>
          <SeguroSalud v-if="visibleSeguroSalud" class="tarjeta" />
          <AtencionClienteMediado v-if="visibleAtencionClienteMediado" class="tarjeta" />
          <SeguroMascotas v-if="visibleSeguroMascotas" class="tarjeta" />
          <SeguroAccidentes v-if="visibleSeguroAccidentes" class="tarjeta" />
          <SeguroNegocios v-if="visibleSeguroNegocios" class="tarjeta" />
          <SeguroMovilidadPersonal v-if="visibleSeguroMovilidadPersonal" class="tarjeta" />
          <SeguroMovilidadVMP v-if="visibleSeguroMovilidadVMP" class="tarjeta" />
        </div>

        <Instrucciones />
      </div>
    </div>

    <SiguenosEn />
    <Pie />
  </div>
</template>

<script>


export default {
  computed: {
    visiblePromocionSaludSeVital() {
      return new Date() < new Date('2027-01-11T00:00:00') &&
        this.$store.state.portfolio.cliente.purezaPuroMMT &&
        this.$store.state.portfolio.tienePolizaSaludHNA == "N" &&
        this.$store.state.portfolio.tienePolizaSaludMMT == "N";
    },

    biggerThanPhone() {
      return this.$store.state.displayBiggerThanPhone;
    },

    visibleNuevoReglamentoCirculacion() {
      const ahora = new Date();
      const fechaFin = new Date('2026-10-31T23:59:59');
      return ahora <= fechaFin;
    },

    visibleAsistenciaAuto() {
      return this.$store.state.portfolio.tienePolizaConAv == "S";
    },
   
    visibleAtencionClienteMediado() {
      return !this.$store.state.portfolio.cliente.purezaPuroMMT;
    },

    visibleSeguroSalud() {

      const ahora = new Date();
      const fechaInicio = new Date('2026-07-01T00:00:00');
      const isMostrarHoy =  ahora >= fechaInicio;
      const mostrarSeguroSalud = isMostrarHoy && this.$store.state.portfolio.cliente.purezaPuroMMT &&
        this.$store.state.portfolio.tienePolizaSaludHNA == "N" &&
        this.$store.state.portfolio.tienePolizaSaludMMT == "N" && 
        this.$store.state.portfolio.cliente.edad != null && 
        this.$store.state.portfolio.cliente.edad < 65;
  
      return mostrarSeguroSalud;
        
    },

    visiblePromocionSeguroSalud1MesGratis(){
      const ahora = new Date();
      const fechaFin = new Date('2026-06-30T23:59:59');
      const isMostrarHoy =   ahora <= fechaFin;
      
      const mostrarSeguroSalud = isMostrarHoy && this.$store.state.portfolio.cliente.purezaPuroMMT &&
        this.$store.state.portfolio.tienePolizaSaludHNA == "N" &&
        this.$store.state.portfolio.tienePolizaSaludMMT == "N" &&
        this.$store.state.portfolio.cliente.edad != null && 
        this.$store.state.portfolio.cliente.edad < 65;
  
      return mostrarSeguroSalud;
    },

    visibleSeguroMovilidadVMP() {
      return (
        this.$store.state.portfolio.cliente.purezaPuroMMT &&
        this.$store.state.portfolio.tienePolizaMovilidadVMP == "N"
      );
    },

    visibleSeguroMovilidadPersonal() {
      return (
        this.$store.state.portfolio.cliente.purezaPuroMMT &&
        this.$store.state.portfolio.tienePolizaMovilidadPersonal == "N"
      );
    },

    visibleSeguroNegocios() {
      return (
        this.$store.state.portfolio.cliente.purezaPuroMMT &&
        this.$store.state.portfolio.tienePolizaNegocio == "N"
      );
    },

    visibleSeguroAccidentes() {
      return (
        this.$store.state.portfolio.cliente.purezaPuroMMT &&
        this.$store.state.portfolio.tienePolizaAccidentes == "N"
      );
    },

    visibleSeguroMascotas() {
      return (this.$store.state.portfolio.cliente.purezaPuroMMT &&
        this.$store.state.portfolio.tienePolizaMascotas == "N");
    },

    visibleTraeUnAmigo() {
      return this.$store.state.portfolio.nsg("lstCodigosAmigo.length") > 0;
    },

    visibleSeguroHogar() {
      return (
        this.$store.state.portfolio.cliente.purezaPuroMMT &&
        this.$store.state.portfolio.tienePolizaHogar == "N"
      );
    },

    visibleSeguroDecesos() {
      return this.$store.state.portfolio.visiblePromocionDecesosPremium;
    },

    visiblePromocionBlackFriday2025(){
      const ahora = new Date();
      const fechaInicio = new Date('2025-11-17T00:00:00');
      const fechaFin = new Date('2025-11-29T23:59:59');
      const isPromocionVigor =  ahora >= fechaInicio && ahora <= fechaFin;
      
      return isPromocionVigor && this.$store.state.portfolio.cliente.purezaPuroMMT ;
    },

    visiblePromocionMesMMTFebrero2026(){
      const ahora = new Date();
      const fechaFin = new Date('2026-02-28T23:59:59');
      const isPromocionVigor =  ahora <= fechaFin;
      return isPromocionVigor && this.$store.state.portfolio.cliente.purezaPuroMMT ;
    },

    visiblePromocionRegaloAspirador(){
     return this.$store.state.portfolio.visiblePromocionRegaloAspirador;
    }, 

  },
};
</script>

<style lang="scss" scoped>
.main {
  display: flex;
}

.menuInicio {
  background-color: $azulOscuroMMT;
  min-width: 240px;
  flex: 1 0 calc(25%);
  padding: 1rem;
}
</style>
